import styles from './styles.module.scss'
import { ContentHeader } from './components/ContentHeader'
import { ScoreInfo } from './components/ScoreInfo'
import { useAppIntl } from 'src/i18n'
import { SummaryModal } from './components/SummaryModal'

export const ContentInfo = ({
  detailedReviewItems,
  getGeneralRatingScore,
  lowerContent,
}) => {
  const intl = useAppIntl()

  return (
    <main className={styles.contentInfo}>
      <div className={styles.reviewsContent}>
        {detailedReviewItems.map(review => (
          <section
            key={review.slug}
            id={review.slug}
            className={styles.reviewsContent__section}
          >
            <ContentHeader
              title={review.title}
              getGeneralRatingScore={getGeneralRatingScore}
              ratingsData={review.ratings?.data}
              thumbnail={review.thumbnail}
              affiliateLink={review.affiliateLink}
              slug={review.slug}
              containerWidth={undefined}
              containerHeight={undefined}
            />
            <SummaryModal
              pros={review.pros}
              cons={review.cons}
              summary={review.summary}
            />
            {review.ratings?.data.map((rating, ratingIndex) => (
              <ScoreInfo key={ratingIndex} ratingData={rating} />
            ))}
            <div className={styles.reviewDeal}>
              <div className={styles.reviewDeal__offerContainer}>
                <p className={styles.reviewDeal__title}>{review.title}</p>
                <p className={styles.reviewDeal__offer}>{review.offer}</p>
              </div>
              <a
                className={styles.reviewDeal__button}
                href={review.affiliateLink}
                target='_blank'
                rel='noopener noreferrer nofollow'
              >
                {intl.t('review.score.get')}
              </a>
            </div>
          </section>
        ))}
        <article
          id='lowerContent'
          className={styles.lowerContent}
          dangerouslySetInnerHTML={{ __html: lowerContent }}
        />
      </div>
    </main>
  )
}
